/**
 * The sun mark from the logo (mustard top, burnt-orange stripes), as an SVG favicon.
 * Mirrors components/LogoMark.tsx so the browser tab matches the header.
 */
const SUN_MARK_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
<defs><clipPath id="s"><circle cx="20" cy="20" r="19"/></clipPath></defs>
<g clip-path="url(#s)">
<rect x="0" y="0" width="40" height="20" fill="#e2a33a"/>
<g fill="#b8431a">
<rect x="0" y="22" width="40" height="4.5"/>
<rect x="0" y="28.5" width="40" height="3.5"/>
<rect x="0" y="34" width="40" height="2.5"/>
<rect x="0" y="38.25" width="40" height="1.75"/>
</g></g></svg>`;

/** Replaces any existing tab icon with the sun mark. */
export function applyFavicon() {
  if (typeof document === "undefined") return;
  const href = `data:image/svg+xml,${encodeURIComponent(SUN_MARK_SVG)}`;

  document.querySelectorAll<HTMLLinkElement>('link[rel~="icon"]').forEach((el) => el.remove());

  const link = document.createElement("link");
  link.rel = "icon";
  link.type = "image/svg+xml";
  link.href = href;
  document.head.appendChild(link);
}
